import { FolkDistanceFieldWebGPU } from '../folk-distance-field-webgpu';
FolkDistanceFieldWebGPU.define();
export { FolkDistanceFieldWebGPU };
//# sourceMappingURL=folk-distance-field-webgpu.js.map